<div class="filter-button">
	<button
		(click)="openFilterModal()"
		[disabled]="!filter"
		data-bs-toggle="modal"
		data-bs-target="#filter"
		type="button"
		class="btn-switch"
	>
		<i class="fal fa-filter pr-2"></i>
		FILTROS
	</button>
</div>

<div
	class="modal right fade"
	id="filter"
	tabindex="-1"
	role="dialog"
	aria-labelledby="exampleModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<div class="row d-flex justify-content-between">
					<div class="col-auto p-0">
						<button class="btn btn-sm btn-primary" (click)="submit()" data-bs-dismiss="modal">
							<i class="fal fa-check pr-2 align-middle"></i><span class="align-middle">APLICAR</span>
						</button>
					</div>
					<div class="col-auto p-0">
						<button class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">CANCELAR</button>
					</div>
				</div>
			</div>

			<div *ngIf="filterReady">
				<div class="modal-body" *ngFor="let sideFilter of sideFilterConfiguration">
					<div class="row d-flex justify-content-between header-filter-group">
						<div class="col-auto" *ngIf="sideFilter.useMatTree">
						</div>
					</div>
					<div *ngIf="!sideFilter.useMatTree">
						<div class="d-flex align-content-center m-b-10">
							<div class="title-filter">{{ sideFilter.title }}</div>
							<div class="ms-auto trash-icon d-flex align-items-center">
								<div class="col-auto pr-4">
									<a (click)="cleanFilter(sideFilter)" role="button">
										<i class="fal fa-trash-alt pr-2 align-middle"></i><span class="align-middle">LIMPAR</span>
									</a>
								</div>
							</div>
						</div>
						<div class="card-per-filter">
							<div class="box-filter">
								<div class="">
									<app-checkbox-mat
										[subAreasOptions]="getFilter(sideFilter.attrFilter)"
										[attrLabel]="sideFilter.attrLabel"
										(selectEvt)="selectEvt($event, sideFilter)"
										[attrFilterState]="sideFilter.attrFilter"
										[onlySelectedOneOption]="sideFilter.onlySelectedOneOption"
									>
									</app-checkbox-mat>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
